import Vue from "vue";
import Vuex from "vuex";
import * as notification from "@/store/modules/notification.js";
import * as announcement from "@/store/modules/announcement.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    notification,
    announcement
  },
  state: {
    loading: false,
    profile_complete: true,
    user_history: [],
    user_avatar: "",
    previous_route: null,
    applicant_fields: [
      "firstname",
      "lastname",
      "mobile",
      "street",
      "street_number",
      "postal_code",
      "city",
      "bsn_number",
      "id_image",
      "vog_image",
      "search_profession_id",
      "search_degree_id",
      "account_name",
      "account_number",
      "cao_id",
      "search_distance",
      "search_lat",
      "search_lng",
      // "search_availability",
      // "search_available",
      "educations"
    ],
    company_fields: [
      "name",
      "telephone",
      // "street",
      // "street_number",
      // "postal_code",
      // "city",
      "contact_salutation",
      "contact_firstname",
      "contact_infix",
      "contact_lastname",
      "about",
      "addresses"
    ],
    month_names: [
      "januari",
      "februari",
      "maart",
      "april",
      "mei",
      "juni",
      "juli",
      "augustus",
      "september",
      "oktober",
      "november",
      "december"
    ]
  }
});
